import { useEffect, useState } from 'react';

import useAutoCredRequestId from '@/components/App/NewOrder/hooks/useAutoCredRequestId';
import { autoCreditApi } from '@/integrations/app.api/auto-credit.api';

import { type HistoryDataSourceInterface } from '../table-data-source';
import { type AutoCreditHistoryResponseInterface } from '../types/auto-credit-history';

interface IProps {
  shouldRequest: boolean;
}

const useAutoCreditHistory = ({ shouldRequest }: IProps) => {
  const { requestId } = useAutoCredRequestId();

  const [autoCreditData, setAutoCreditData] = useState<
    HistoryDataSourceInterface[] | undefined
  >(undefined);
  const [autoCreditLoading, setAutoCreditLoading] = useState(false);

  useEffect(() => {
    if (!shouldRequest || !requestId) return;

    (async () => {
      setAutoCreditLoading(true);
      try {
        const response =
          await autoCreditApi.getOrderHistory<
            AutoCreditHistoryResponseInterface[]
          >(requestId);
        if (!response?.[0]?.result) return;

        setAutoCreditData(
          response[0].result.map((item) => ({
            comment: item.data.description,
            date: item.create_date,
            id: item.create_date,
            initiator: item.data.initiator
          }))
        );
      } finally {
        setAutoCreditLoading(false);
      }
    })();
  }, [shouldRequest, requestId]);

  return {
    autoCreditData,
    totalAutoCreditData: autoCreditData?.length,
    autoCreditLoading
  };
};

export default useAutoCreditHistory;
